<template>
  <div class="engine">
    <div class="label">{{ $t('common.modals.create_external.engines.rasa.rasaSettings') }}</div>

    <div class="engine--description">
      {{ $t('common.modals.create_external.engines.rasa.readMoreAbout') }}
      <a class="engine--info-url" :href="rasaUrl" target="_blank">
        {{ $t('common.modals.create_external.engines.rasa.here') }}
      </a>
    </div>

    <or-textbox
      v-model="localRasaModel.settings.url"
      :label="$t('common.modals.create_external.engines.rasa.url')"
      :placeholder="$t('common.modals.create_external.engines.rasa.enterUrl')"
    />

    <or-code
      v-model="localRasaModel.settings.queryParamsTemplate"
      :label="$t('common.modals.create_external.engines.rasa.queryParams')"
      mode="json"
      :full-screen="false"
    />

    <or-code
      v-model="localRasaModel.settings.customHeaders"
      :label="$t('common.modals.create_external.engines.rasa.customHeaders')"
      mode="json"
      :full-screen="false"
    />

    <or-code
      v-model="localRasaModel.settings.bodyTemplate"
      :label="$t('common.modals.create_external.engines.rasa.bodyTemplate')"
      mode="json"
      :full-screen="false"
      :invalid="!!settingsErrors.bodyTemplate"
      :error="settingsErrors.bodyTemplate"
    />
  </div>
</template>

<script>
import { RASA_DOCS_URL } from '@/config'

export const getDefaultRasaSettings = () => ({
  url: '',
  customHeaders: JSON.stringify({}),
  queryParamsTemplate: JSON.stringify({}),
  bodyTemplate: JSON.stringify({})
})

export default {
  props: {
    rasaModel: {
      settings: {
        url: String,
        bearerToken: String,
        queryParamsTemplate: String,
        bodyTemplate: String
      }
    },
    errors: {
      settings: {
        bodyTemplate: String
      }
    }
  },

  data () {
    return {
      rasaUrl: RASA_DOCS_URL
    }
  },

  computed: {
    settingsErrors () {
      return this.$props.errors.settings || {}
    },

    localRasaModel: {
      get () {
        return this.$props.rasaModel
      },
      set (value) {
        this.$emit('update:rasaModel', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
